<template>
  <div>
    <v-dialog
      v-model="dialog"
      width="400px">
      <div class="dialog-container">
        <div class="dialog-header">
          <h4>{{title}}</h4>
        </div>
        <div class="dialog-body flex">
          <div class="tips">
            {{tips}}
          </div>
          <v-button
            v-for="(v,i) in tickets"
            :key="i"
            icon="arrow-up-right-from-square"
            @click="copyNum(v.num)">{{v.name}} #{{v.num}}</v-button>
        </div>
        <div class="dialog-footer">
          <div class="btn-group flex-sb">
            <v-button
              class="cancel"
              @click="handleCancel">Cancel</v-button>
            <v-button
              class="continue"
              @click="handleContinue">Continue</v-button>
          </div>
        </div>
      </div>
    </v-dialog>
  </div>
</template>

<script>
export default {
  name: 'EndorsRenewTips',
  props:{
    endorseNumber:{
      type: [String, Number],
      default: ''
    },
    cliams:{
      type: Array,
      default: () => []
    },
    renewOrderSn: {
      type: String,
      default: ''
    },
    stts: {
      type: [String, Number],
      default: 0
    }
  },
  data () {
    return {
      dialog: false,
      tips: '',
      tickets:[]
    }
  },
  computed:{
    title(){
      let title = 'Associated Renewal'
      if(this.endorseNumber || this.cliams.length > 0){
        title = 'Associated Ticket'
      }
      return title
    },
  },
  watch:{
    endorseNumber:{
      immediate: true,
      handler(val){
        if(val){
          this.setInfo()
        }
      }
    },
    cliams:{
      immediate: true,
      deep: true,
      handler(val){
        if(val.length){
          this.setInfo()
        }
      }
    },
    renewOrderSn:{
      immediate: true,
      handler(val){
        if(val){
          this.setInfo()
        }
      }
    }
  },
  methods: {
    changeDialog(){
      this.dialog = !this.dialog
    },

    copyNum(num){
      console.log('click')
      let textareaElement = document.createElement('textarea')
      textareaElement.setAttribute('readonly', 'readonly') // 防止弹出输入编辑
      textareaElement.value = num //将需要拷贝的内容设置到textarea元素中。
      document.body.appendChild(textareaElement )
      textareaElement .select() //选中textarea元素，以备调用系统copy函数复制其中的内容。
      let isSuccess = document.execCommand('copy')
      this.$NewMessageBox({
        title: 'Copy Number',
        message: 'The Number has been copied to your clipboard',
        confirmBtn:'Done',
        btnType:'success'
      })
    },

    handleCancel(){
      this.dialog = false
    },
    
    handleContinue(){
      this.dialog = false
      this.$emit('continue')
    },
    
    setInfo(){
      if(this.endorseNumber){
        this.tips = 'This policy has an unsettled endorsement ticket. Continue?'
        this.setTickets('Endorsement Ticket', this.endorseNumber)
      }
      if(this.cliams.length > 0){
        this.tips = 'This policy has an unsettled claim ticket. Continue?'
        this.cliams.map(item => {
          this.setTickets('Claim Ticket', item)
        })
      }
      if(this.renewOrderSn && this.stts < 401){
        this.tips = 'This ticket’s policy has an unsettled renewal quote. Continue?'
        this.setTickets('Renewal Quote', this.renewOrderSn)
      }
      if(this.renewOrderSn && this.stts >= 401){
        this.tips = 'This ticket’s policy has a renewed policy. Continue?'
        this.setTickets('Policy', this.renewOrderSn)
      }
    },

    setTickets(name, num){
      let ticket_num_list = []
      Object.values(this.tickets).map(item => {
        ticket_num_list.push(item.num)
      })
      if(!ticket_num_list.includes(num)){
        this.tickets.push({name, num})
      }
    }
  },
}
</script>
<style lang='scss' scoped>
/deep/.el-dialog{
  border-radius: 6px;
}
.dialog-container {
  .dialog-header{
    padding:16px;
    background: #F6F8FA;
    border: 1px solid #E1E4E8;
    border-radius: 6px 6px 0px 0px;
    h4 {
      font-weight: 600;
    }
  }
  .dialog-body{
    padding: 20px;
    flex-direction: column;
    .el-button{
      width: 100%;
      margin-top: 20px;
      color: #0366D6;
      font-weight: 600;
      font-size: 14px;
      height: 32px;
      background: #FAFBFC;
      border: 1px solid rgba(27, 31, 35, 0.15);
      box-shadow: 0px 1px 0px rgba(27, 31, 35, 0.04);
      border-radius: 6px;
      & + .el-button{
        margin-left: 0;
      }
    }
  }
  .dialog-footer{
    padding: 15px;
    padding-top: 0;
    .cancel{
      background: #FAFBFC;
      border: 1px solid rgba(27, 31, 35, 0.15);
      box-shadow: 0px 1px 0px rgba(27, 31, 35, 0.04);
      border-radius: 6px;
    }
    .continue{
      background: #2EA44F;
      border: 1px solid rgba(27, 31, 35, 0.15);
      box-shadow: 0px 1px 0px rgba(27, 31, 35, 0.1);
      border-radius: 6px;
      color: #FFFFFF;
    }
  }
}
</style>
